import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  protected constructor(
    private http: HttpClient,
    protected configService: ConfigService,
  ) {}

  // returns an observable of type T in the form of JSON
  public get<T>(url: string): Observable<T> {
    return this.http.get<T>(`${this.configService.config.apiUrl}${url}`);
  }

  public getForText(url: string): Observable<any> {
    return this.http.get(`${this.configService.config.apiUrl}${url}`, { responseType: 'text' });
  }

  public getHtmlTemplate(url: string): Observable<string> {
    return this.http.get(`/assets/${url}`, { responseType: 'text' });
  }

  public put<T>(url: string, itemToUpdate): Observable<T> {
    return this.http.put<T>(`${this.configService.config.apiUrl}${url}`, itemToUpdate);
  }

  public post<T>(url: string, body: any): Observable<T> {
    return this.http.post<T>(`${this.configService.config.apiUrl}${url}`, body);
  }

  public postForText(url: string, body: any): Observable<any> {
    return this.http.post(`${this.configService.config.apiUrl}${url}`, body, { responseType: 'text' });
  }

  public patch<T>(url: string, body: any): Observable<T> {
    return this.http.patch<T>(`${this.configService.config.apiUrl}${url}`, body);
  }

  public delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${this.configService.config.apiUrl}${url}`);
  }

  public getAzureFile(url: string, fileType: string): Observable<any> {
    return this.http
      .get(url, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(map((res: any) => new Blob([res.body], { type: fileType })));
  }
}
